import "./styles/kitchenproductCard.css";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import { IoTimerOutline } from "react-icons/io5";

import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";

const unitMap = {
    1: "gm",
    2: "kg",
    3: "ml",
    4: "ltr",
    5: "pcs",
};

const KitchenProductTicket = (props) => {

    const { startTime, selectDate, item, type, buynow, fromPage, quantity, isQuantityUpdating, onQuantityChange } = props;


    const { vendor_id } = useParams();
    const [data, setData] = useState(props.Data);
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = useState(null);
    const [expiredStatus, setExpiredStatus] = useState(false);
    const location = useLocation()
    const [ticketStartTimeDate, setTicketStartTimeDate] = useState(null)
    const timerRef = useRef(null);
 
    const DEFAULT_IMAGE_URL = "https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/FoodPlaceholderRect.png";
    const ticketQuantity = Number(quantity) || 1;
    const showQuantityEditor = fromPage == "reviewpay" && typeof onQuantityChange === "function";

    useEffect(() => {
        setData((prevData) => (prevData !== item ? item : prevData));
        const storedTime = localStorage.getItem("dateandtime");
        setTicketStartTimeDate(storedTime ? JSON.parse(storedTime) : null)
    }, [vendor_id, item]);


    const bookBeforeTimes = [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 9 },
        { id: 5, value: 12 },
        { id: 6, value: 24 },
        { id: 7, value: 48 },

    ];

    useEffect(() => {
        const checkIfExpired = () => {
            const now = moment(); // Get current time
            const bookBefore = item.book_before;
            let deadline = moment(bookBefore);

            setExpiredStatus(now.isAfter(deadline) ? true : false);
        };

        checkIfExpired();
    }, [item]);


    const getValueById = (id) => {
        const item = bookBeforeTimes.find((time) => time.id == id);
        return item ? item.value : 0;
    };

    const calculateTimeLeft = () => {
        const target = item?.bookBefore || item?.book_before || item?.book_before_datetime || item?.bookBeforeDate;

        if (target && moment(target).isValid() && isNaN(Number(target))) {
            const now = moment();
            const bookBefore = moment(target);

            if (now.isAfter(bookBefore)) {
                setTimeLeft("Expired");
                if (timerRef.current) clearInterval(timerRef.current);
                return;
            }

            const duration = moment.duration(bookBefore.diff(now));
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            let timeString = "";
            if (days > 0) {
                timeString = `${days}d ${hours}h`;
            } else if (hours > 0) {
                timeString = `${hours}h ${minutes}m`;
            } else {
                timeString = `${minutes}m ${seconds}s`;
            }
            setTimeLeft(timeString);
            return;
        }

        const now = moment();
        const bookBeforeHours = getValueById(Number(item?.book_before)) || 0;

        const startDateTime = moment(
            `${selectDate || ticketStartTimeDate?.selectDate} ${startTime || ticketStartTimeDate?.startTime}`,
            ["ddd MMM DD YYYY hA", "ddd MMM DD YYYY hh:mm A", "D MMMM YYYY hA", "D MMMM YYYY hh:mm A", "DD-MM-YYYY hA", "YYYY-MM-DD hA"]
        );

        if (!startDateTime.isValid()) {
            return;
        }

        const deadline = startDateTime.clone().subtract(bookBeforeHours, "hours");

        if (now.isAfter(deadline)) {
            setTimeLeft("Expired");
            return;
        }

        if (now.isBefore(deadline)) {
            const duration = moment.duration(deadline.diff(now));

            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            const timeString = [
                days > 0 ? `${days}d` : "",
                hours > 0 ? `${hours}h` : "",
                minutes > 0 ? `${minutes}m` : ""
            ]
                .filter(Boolean)
                .join(" ");

            setTimeLeft(timeString || "0s");
        }
    };

    useEffect(() => {
        calculateTimeLeft();

        timerRef.current = setInterval(() => {
            calculateTimeLeft();
        }, 1000);

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [item?.bookBefore, item?.book_before, item?.book_before_datetime, item?.bookBeforeDate, startTime, selectDate, ticketStartTimeDate]);


    return (
        // <div className="kitchen-product-card">
        //     <div className="kitchen-product-img-wrapper">
        //         <img src={item.product_image ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.ticket_img}`
        //             : DEFAULT_IMAGE_URL} onError={(e) => e.target.src = DEFAULT_Ticket_IMAGE_URL}
        //             alt={item?.name} className="kitchen-product-img" />
        //     </div>
        //     <div className="kitchen-product-content"> 
        //         <div className="d-flex justify-content-between">
        //             <h4 className="kitchen-product-title d-flex align-items-center gap-1">
        //                 <img src={item?.ticket_food_type == "1" ? vegIcon : nonvegIcon}
        //                     alt={item?.ticket_food_type} className="kitchen-product-food-icon" />
        //                 {item?.ticket_name}
        //             </h4>

        //             <div className="catalog-badge">
        //                 <span className="catalog-text"> {timeLeft}</span>
        //             </div>
        //         </div>
        //         <p className=" kitchen-product-desc ">
        //             {(item.about).slice(0, 40) + (item?.about?.length > 40 ? "..." : "").toUpperCase()}
        //         </p>

        //         <div className="kitchen-product-footer">
        //             <span className="kitchen-product-price"><span className="rupeeIcon">₹</span>{item?.discount_status == 1 ? item?.discount : item.ticket_price}</span>
        //             <button className="kitchen-product-btn">
        //                 Buy Now
        //             </button>
        //         </div>
        //     </div>
        // </div>

        <div className="kitchen-product-card">
            <div className="kitchen-product-img-wrapper">
                <img
                    src={item.product_image
                        ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${item.ticket_img}`
                        : DEFAULT_IMAGE_URL}
                    onError={(e) => (e.target.src = DEFAULT_IMAGE_URL)}
                    alt={item?.name}
                    className="kitchen-product-img"
                />
            </div>

            <div className="kitchen-product-content position-relative">
                {fromPage?.toLowerCase() !== "orderpass" && timeLeft && (
                    <div className="catalog-badge">
                        <span className="catalog-text"><IoTimerOutline size={18} color="#9C6ADE" /> {timeLeft}</span>
                    </div>
                )}
                <h4 className={`kitchen-product-title ${fromPage?.toLowerCase() !== "orderpass" && timeLeft ? "has-badge" : ""}`}>
                    {item?.ticket_name}
                </h4>

                <div className="d-flex align-items-center gap-1">
                    <img
                        src={item?.ticket_food_type == "1" ? vegIcon : nonvegIcon}
                        alt={item?.ticket_food_type}
                        className="kitchen-product-food-icon"
                    />
                    {item?.product_quantity_value && unitMap[item?.product_quantity] && (
                        <span className="kitchen-product-qty">
                            {item.product_quantity_value} {unitMap[item.product_quantity]}
                        </span>
                    )}
                </div>

                <p className="kitchen-product-desc">
                    {(item.about).slice(0, 40) + (item?.about?.length > 40 ? "..." : "").toUpperCase()}
                </p>

                <div className="kitchen-product-footer">
                    <span className="kitchen-product-price">    
                        <span className="rupeeIcon">₹</span>
                        {item?.discount ? item?.discount : item.ticket_price}
                    </span>
                    {showQuantityEditor ? (
                        <div className="kitchen-ticket-qty-selector">
                            <button
                                type="button"
                                className="kitchen-ticket-qty-btn"
                                disabled={isQuantityUpdating || ticketQuantity <= 1}
                                onClick={() => onQuantityChange("remove")}
                            >
                                -
                            </button>
                            <span className="kitchen-ticket-qty-value">{ticketQuantity}</span>
                            <button
                                type="button"
                                className="kitchen-ticket-qty-btn"
                                disabled={isQuantityUpdating}
                                onClick={() => onQuantityChange("add")}
                            >
                                +
                            </button>
                        </div>
                    ) : buynow == "true" &&
                        <button className="kitchen-product-btn" onClick={() => navigate(`/ticket/${item?.vendor_id}/${item?.ticket_id}`, {
                            state: { select_date: item?.request_date, type: 1 },
                        })}>
                            Buy Now
                        </button>}
                </div>
            </div>
        </div>
    );
};

export default KitchenProductTicket;
